export default "__VITE_ASSET__fa484beb__"